import { openModal } from '@core/components/ModalStack';
import { EditProjectModalProps } from './EditProjectModal';

export async function openEditProjectModal(props: EditProjectModalProps) {
  const { EditProjectModal } = await import('./EditProjectModal');

  openModal(EditProjectModal, props);
}
